module.exports = __webpack_public_path__ + "img/4.1bb4cf5b.jpg";